import { strToRegexpPattern } from '@wiloke/functions';

export const replaceExactKeyword = (str: string, source: string, target: any) => {
  // 2 dấu cách đầu tiên để vá lỗi cho function "replaceExactKeyword"
  const _str = ` ${str} `;
  return _str.replace(new RegExp(`.${strToRegexpPattern(source)}.`, 'g'), value => {
    const isStartValid =
      value.startsWith(' ') ||
      value.startsWith('\n') ||
      // Trường hợp collections[product_settings.collection]
      value.startsWith('[');
    const isEndValid =
      value.endsWith(' ') ||
      value.endsWith('\n') ||
      // Trường hợp collections[product_settings.collection]
      value.endsWith(']');
    if (isStartValid && isEndValid) {
      return value.replace(source, target);
    } else {
      return value;
    }
  });
};

export const isExistExactKeyword = (str: string, source: string) => {
  // 2 dấu cách đầu tiên để vá lỗi cho function "replaceExactKeyword"
  const _str = ` ${str} `;
  let result = false;
  _str.replace(new RegExp(`.${strToRegexpPattern(source)}.`, 'g'), value => {
    const isStartValid =
      value.startsWith(' ') ||
      value.startsWith('\n') ||
      // Trường hợp collections[product_settings.collection]
      value.startsWith('[');
    const isEndValid =
      value.endsWith(' ') ||
      value.endsWith('\n') ||
      // Trường hợp collections[product_settings.collection]
      value.endsWith(']');
    if (isStartValid && isEndValid) {
      result = true;
    }
    return '';
  });

  return result;
};

export const convertToSyntaxDataType = (value: boolean | number | string): string => {
  if (typeof value === 'boolean') {
    return `${value}`;
  }
  if (typeof value === 'number') {
    return `${value}`;
  }
  if (typeof value === 'string') {
    if (/".*"/g.test(value)) {
      return `'${value}'`;
    }
    return `"${value}"`;
  }
  return value;
};
